import React from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Form, Input } from 'semantic-ui-react';
import { findWithUUID } from '@/utils/uuidHelper';
import { findError, validationClasses } from '@/utils/errors';
import fields, { fieldLengths, globalFieldLengths } from '@/constants/fields';
import FormValidationError from '@/components/errors/FormValidationError';
import MarkdownEditor from '@/components/text-editors/MarkdownEditor';
import { updateVocabularyRoleActionProperties } from '../actions';

const VocabularyRoleActionForm = ({ roleAction, updateErrors, updateProperties }) => {
  const intl = useIntl();
  const roleActionId = `role-action-${roleAction.uuid}`;
  const errors = updateErrors.filter(({ context: { uuid } }) => uuid === roleAction.uuid);
  const nameError = findError(errors, 'link', [fields.NAME]);
  const titleError = findError(errors, 'link', [fields.TITLE]);
  const hrefError = findError(errors, 'link', [fields.URL]);
  const targetError = findError(errors, 'link', [fields.TARGET]);

  return (
    <Form autoComplete="off">
      <Form.Group widths="equal">
        <FormValidationError labelId="table.header.name" error={nameError}>
          <Input
            className={validationClasses(nameError)}
            type="text"
            fluid
            value={roleAction.name}
            maxLength={globalFieldLengths.name}
            onChange={(e) => updateProperties(roleAction.uuid, { name: e.target.value })}
            placeholder={intl.formatMessage({ id: 'vocabulary.role-actions.name.placeholder' })}
          />
        </FormValidationError>
      </Form.Group>
      <Form.Group widths="equal">
        <FormValidationError labelId="table.header.title" error={titleError}>
          <Input
            className={validationClasses(titleError)}
            type="text"
            fluid
            value={roleAction.title}
            maxLength={globalFieldLengths.name}
            onChange={(e) => updateProperties(roleAction.uuid, { title: e.target.value })}
            placeholder={intl.formatMessage({ id: 'vocabulary.role-actions.title.placeholder' })}
          />
        </FormValidationError>
      </Form.Group>
      <Form.Group widths="equal">
        <FormValidationError labelId="table.header.url" error={hrefError}>
          <Input
            className={validationClasses(hrefError)}
            type="text"
            fluid
            value={roleAction.href}
            maxLength={globalFieldLengths.url}
            onChange={(e) => updateProperties(roleAction.uuid, { href: e.target.value })}
            placeholder={intl.formatMessage({ id: 'vocabulary.role-actions.url.placeholder' })}
          />
        </FormValidationError>
        <FormValidationError labelId="table.header.target" error={targetError}>
          <Input
            className={validationClasses(targetError)}
            type="text"
            fluid
            value={roleAction.target}
            name="target"
            maxLength={fieldLengths.tiny}
            onChange={(e) => updateProperties(roleAction.uuid, { target: e.target.value })}
          />
        </FormValidationError>
      </Form.Group>
      <Form.Group widths="equal">
        <Form.Field>
          <label htmlFor={`${roleActionId}-content`}>{intl.formatMessage({ id: 'table.header.content' })}</label>
          <MarkdownEditor
            id={`${roleActionId}-content`}
            value={roleAction.content}
            onChange={(value) => updateProperties(roleAction.uuid, { content: value })}
          />
        </Form.Field>
      </Form.Group>
    </Form>
  );
};

const mapStateToProps = ({
  vocabularies: { activeVocabulary: { roleActions } },
}, { roleActionUUID }) => ({
  roleAction: findWithUUID(roleActions, roleActionUUID),
});

const mapDispatchToProps = {
  updateProperties: updateVocabularyRoleActionProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(VocabularyRoleActionForm);
